import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: {
      signin: {
        button: 'Sign In',
        message: 'Selfly Cabinet Refill',
      },
      common: {
        signout: 'Sign Out',
        redirecting: 'Redirecting',
        start_read_qr: 'Start by reading device QR-code',
        no_permission_to_replenish_device:
          'You do not have required permissions to refill this cabinet',
        please_wait_for_door_open: 'Please wait until the door is opened...',
        language: 'Select language',
        refill_app: 'Refill app',
        plan_help_text:
          'This is the target plan which indicates the amount of products to be added or removed from the cabinet',
        no_plan: 'There is no active refill plan for this cabinet',
        yes: 'Yes',
        no: 'No',
        add: 'Add',
        remove: 'Remove',
        refill: 'Refill',
        refillPlan: 'Refill Plan',
        settings: 'Settings',
        user: 'User',
        products: 'Products',
        target: 'Target',
        close: 'Close',
        refillNote: 'Refill note',
        planogramHelpText:
          'Planogram layout for the placement of products on cabinet shelves during refill.',
        planogramMissing: 'No planogram has been defined.',
        planogramImageHelpText: 'Planogram image for the refill plan.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Warning: Your refill plan is not met yet, you can check the refill plan tab to see the missing items.',
        inventoryInfoSuccess:
          'Congratulations, you have achieved your refill plan!',
        inventory: 'Inventory',
        screen: 'Screen',
        shelf: 'Shelf',
        slot: 'Slot',
        start_calibration: 'Start calibration',
        end_calibration: 'End calibration',
        unableToLoadPlanogram: 'Unable to load planogram',
        selectSlot:
          'Press "Start" and choose a slot below to begin calibration.',
        pressSlotToCalibrate:
          'Select "Next" if you are ready to start calibration for the chosen slot.',
        confirmSlotEmptied:
          'Please ensure the slot is empty. If any products are in the slot, remove them first. Then, click the "Confirm" button to verify that the slot is clear.',
        back: 'Back',
        next: 'Next',
        confirm: 'Yes, confirm',
        cancel: 'Cancel',
        cancelCalibration:
          'Are you sure you want to cancel the calibration for this slot?',
        selectProduct: 'Select a product',
        slotNotAssigned:
          'A product has been added to the planogram, but it has not yet been assigned to specified slot in the cabinet.',
        productMismatched:
          'The product assigned to the selected slot differs from the product added to the planogram.',
        productMissing: 'No product has been assigned to the slot yet.',
        searchProduct: 'search product...',
        calibrationInProgress:
          'Please select a slot from the planogram below that you would like to train the product for',
        placeProducts:
          'Please place a minimum of 3 and a maximum of 9 products in the selected slot.',
        productMissingInPlanogram:
          'A product has been assigned to the selected slot but is not listed in the planogram.',
        confirmCalibrationProduct:
          'Are you sure you have placed {{count}} products in the selected slot?',
        updateSlotInventory: 'Update slot inventory',
        updating: 'Updating...',
      },
      cabinet: {
        label_name: 'Cabinet',
        door_lock: 'End',
        door_unlock: 'Start',
        applying_setting: 'Applying setting',
        filter_instruction:
          "Select whether to display only refilled items or all items on the cabinet's refill screen",
        all_items: 'All items',
        refilled_items: 'Refilled items',
        refill_question:
          'Do you want to mark the active refill plan for this cabinet as completed?',
        refill_warning_question:
          'Your active refill plan for this cabinet is not yet achieved, do you still want to mark it as completed?',
      },
      error: {
        forbidden: 'You do not have permission to refill this device',
        unknown: 'Something went wrong...',
        error: 'Error',
        not_found_plan: 'No refill plan was found for this device',
        plan_status: 'Refill plan status could not be updated',
        cabinetState: 'Could not fetch the cabinet status.',
      },
    },
    fi: {
      signin: {
        button: 'Kirjaudu sisään',
        message: 'Selfly-kaapin täyttö',
      },
      common: {
        signout: 'Kirjaudu ulos',
        redirecting: 'Uudelleenohjataan',
        start_read_qr: 'Aloita lukemalla laitteen QR-koodi',
        no_permission_to_replenish_device:
          'Sinulla ei ole tarvittavia oikeuksia tämän kaapin täyttämiseen',
        please_wait_for_door_open: 'Odota oven avautumista...',
        language: 'Valitse kieli',
        refill_app: 'Täyttösovellus',
        plan_help_text:
          'Tämä on tavoitesuunnitelma, joka kertoo kaappiin lisättävien tai siitä poistettavien tuotteiden määrän',
        no_plan: 'Tälle kaapille ei ole aktiivista täyttösuunnitelmaa',
        yes: 'Kyllä',
        no: 'Ei',
        add: 'Lisää',
        remove: 'Poista',
        refill: 'Täyttö',
        refillPlan: 'Täyttösuunnitelma',
        settings: 'Asetukset',
        user: 'Käyttäjä',
        products: 'Tuotteet',
        target: 'Tavoite',
        close: 'Sulje',
        refillNote: 'Täyttömuistutus',
        planogramHelpText:
          'Suunnitelma tuotteiden sijoittamiseksi kaapin hyllyille täytön aikana.',
        planogramMissing: 'Planogram ei ole määritelty.',
        planogramImageHelpText: 'Planogram-kuva täyttösuunnitelmalle.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Varoitus: Täyttösuunnitelmaasi ei ole vielä saavutettu, voit tarkistaa täyttösuunnitelma-välilehdestä puuttuvat tuotteet.',
        inventoryInfoSuccess:
          'Onnittelut, olet saavuttanut täyttösuunnitelmasi!',
        inventory: 'Varasto',
        screen: 'Näyttö',
        shelf: 'Hylly',
        slot: 'Paikka',
        start_calibration: 'Aloita kalibrointi',
        end_calibration: 'Lopeta kalibrointi',
        unableToLoadPlanogram: 'Planogrammia ei voi ladata',
        selectSlot:
          'Paina "Aloita" ja valitse alla oleva paikka kalibroinnin aloittamiseksi.',
        pressSlotToCalibrate:
          'Valitse "Seuraava", kun olet valmis aloittamaan kalibroinnin valitulle paikalle.',
        confirmSlotEmptied:
          'Varmista, että paikka on tyhjä. Jos paikassa on tuotteita, poista ne ensin. Napsauta sitten "Vahvista"-painiketta vahvistaaksesi, että paikka on tyhjä.',
        back: 'Takaisin',
        next: 'Seuraava',
        confirm: 'Kyllä, vahvista',
        cancel: 'Peruuta',
        cancelCalibration:
          'Haluatko varmasti peruuttaa tämän paikan kalibroinnin?',
        selectProduct: 'Valitse tuote',
        slotNotAssigned:
          'Tuote on lisätty planogrammiin, mutta sitä ei ole vielä määritetty kaapin tiettyyn paikkaan.',
        productMismatched:
          'Valittuun paikkaan määritetty tuote eroaa planogrammiin lisätystä tuotteesta.',
        productMissing: 'Paikkaan ei ole vielä määritetty tuotetta.',
        searchProduct: 'hae tuotetta...',
        calibrationInProgress:
          'Valitse alta planogrammista paikka, jolle haluat kouluttaa tuotteen',
        placeProducts:
          'Aseta vähintään 3 ja enintään 9 tuotetta valittuun paikkaan.',
        productMissingInPlanogram:
          'Valittuun paikkaan on määritetty tuote, mutta sitä ei ole lueteltu planogrammissa.',
        confirmCalibrationProduct:
          'Oletko varma, että olet asettanut {{count}} tuotetta valittuun paikkaan?',
        updateSlotInventory: 'Päivitä paikkavarasto',
        updating: 'Päivitetään...',
      },
      cabinet: {
        label_name: 'Kaappi',
        door_lock: 'Lopeta',
        door_unlock: 'Aloita',
        applying_setting: 'Päivitetään asetusta',
        filter_instruction:
          'Valitse, näytetäänkö kaapin täyttönäkymässä vain täytetyt vai kaikki tuotteet',
        all_items: 'Kaikki tuotteet',
        refilled_items: 'Täytetyt tuotteet',
        refill_question:
          'Haluatko merkitä tämän kaapin aktiivisen täyttösuunnitelman valmiiksi?',
        refill_warning_question:
          'Aktiivista täyttösuunnitelmaasi tälle kaapille ei ole vielä saavutettu, haluatko silti merkitä sen valmiiksi?',
      },
      error: {
        forbidden: 'Sinulla ei ole oikeutta täyttää tätä laitetta',
        unknown: 'Jotain meni pieleen...',
        error: 'Virhe',
        not_found_plan: 'Tälle laitteelle ei löytynyt täyttösuunnitelmaa',
        plan_status: 'Täyttösuunnitelman tilaa ei voitu päivittää',
        cabinetState: 'Kaapin tilaa ei voitu hakea.',
      },
    },
    bg: {
      signin: {
        button: 'Влизане',
        message: 'Презареждане на шкаф Selfly',
      },
      common: {
        signout: 'Излизане',
        redirecting: 'Пренасочване',
        start_read_qr: 'Започнете с четене на QR-код на устройството',
        no_permission_to_replenish_device:
          'Нямате необходимите разрешения за презареждане на този шкаф',
        please_wait_for_door_open:
          'Моля, изчакайте, докато вратата се отвори...',
        language: 'Изберете език',
        refill_app: 'Приложение за презареждане',
        plan_help_text:
          'Това е целевият план, който показва количеството продукти за добавяне или премахване от шкафа',
        no_plan: 'Няма активен план за презареждане за този шкаф',
        yes: 'Да',
        no: 'Не',
        add: 'Добавете',
        remove: 'Премахнете',
        refill: 'Напълни отново',
        refillPlan: 'Планове за презареждане',
        settings: 'Настройки',
        user: 'Ползвател',
        products: 'Продукти',
        target: 'Цел',
        close: 'Затвори',
        refillNote: 'Бележка за попълване',
        planogramHelpText:
          'Разпределение за подреждане на продукти на рафтовете на шкафа по време на попълване.',
        planogramMissing: 'Не е дефиниран планограма.',
        planogramImageHelpText:
          'Изображение на планограма за плана за попълване.',
        planogram: 'Планограма',
        inventoryInfoWarning:
          'Предупреждение: Вашият план за попълване все още не е изпълнен, можете да проверите таба за плана за попълване, за да видите липсващите артикули.',
        inventoryInfoSuccess:
          'Поздравления, постигнахте своя план за попълване!',
        inventory: 'Инвентар',
        screen: 'Екран',
        shelf: 'Рафт',
        slot: 'Място',
        start_calibration: 'Стартиране на калибриране',
        end_calibration: 'Край на калибриране',
        unableToLoadPlanogram: 'Не може да се зареди планограма',
        selectSlot:
          'Натиснете "Старт" и изберете слот по-долу, за да започнете калибрирането.',
        pressSlotToCalibrate:
          'Изберете "Напред", ако сте готови да започнете калибриране за избрания слот.',
        confirmSlotEmptied:
          'Моля, уверете се, че слотът е празен. Ако има продукти в слота, първо ги премахнете. След това щракнете върху бутона "Потвърди", за да проверите дали слотът е празен.',
        back: 'Назад',
        next: 'Напред',
        confirm: 'Да, потвърди',
        cancel: 'Отмени',
        cancelCalibration:
          'Сигурни ли сте, че искате да отмените калибрирането за този слот?',
        selectProduct: 'Изберете продукт',
        slotNotAssigned:
          'Продукт е добавен към планограмата, но все още не е присвоен към определен слот в шкафа.',
        productMismatched:
          'Продуктът, присвоен на избрания слот, се различава от продукта, добавен към планограмата.',
        productMissing: 'Все още не е присвоен продукт към слота.',
        searchProduct: 'търсене на продукт...',
        calibrationInProgress:
          'Моля, изберете слот от планограмата по-долу, за който искате да обучите продукта',
        placeProducts:
          'Моля, поставете минимум 3 и максимум 9 продукта в избрания слот.',
        productMissingInPlanogram:
          'Продукт е присвоен на избрания слот, но не е посочен в планограмата.',
        confirmCalibrationProduct:
          'Сигурни ли сте, че сте поставили {{count}} продукта в избрания слот?',
        updateSlotInventory: 'Aктуализиране на инвентара на слота',
        updating: 'Актуализиране...',
      },
      cabinet: {
        label_name: 'Шкаф',
        door_lock: 'Край',
        door_unlock: 'Начало',
        applying_setting: 'Настройката се прилага',
        filter_instruction:
          'Изберете дали да показвате само презаредени артикули или всички артикули на екрана за презареждане на шкафа',
        all_items: 'Всички артикули',
        refilled_items: 'Презаредени артикули',
        refill_question:
          'Искате ли да маркирате активния план за презареждане за този шкаф като завършен?',
        refill_warning_question:
          'Вашият активен план за попълване за този шкаф все още не е изпълнен, все пак искате ли да го маркирате като завършен?',
      },
      error: {
        forbidden: 'Нямате разрешение да презареждате това устройство',
        unknown: 'Възникна грешка...',
        error: 'Грешка',
        not_found_plan:
          'Не беше намерен план за презареждане за това устройство',
        plan_status:
          'Състоянието на плана за презареждане не можа да бъде актуализирано',
        cabinetState: 'Не можа да се извлече състоянието на шкафа.',
      },
    },
    it: {
      signin: {
        button: 'Accesso',
        message: 'Rifornimento del frigo Selfly',
      },
      common: {
        signout: 'Uscita',
        redirecting: 'Reindirizzamento',
        start_read_qr: 'Inizia leggendo il codice QR del dispositivo',
        no_permission_to_replenish_device:
          'Non hai le autorizzazioni necessarie per rifornire questo frigo',
        please_wait_for_door_open:
          'Si prega di attendere fino a quando la porta non viene aperta...',
        language: 'Seleziona la lingua',
        refill_app: 'App di rifornimento',
        plan_help_text:
          'Questo è il piano target che indica la quantità di prodotti da aggiungere o rimuovere dalla vetrinetta',
        no_plan:
          'Non esiste alcun piano di ricarica attivo per questa vetrinetta',
        yes: 'Sì',
        no: 'No',
        add: 'Aggiungi',
        remove: 'Rimuovi',
        refill: 'Refill',
        refillPlan: 'Refill Plan',
        settings: 'Settings',
        user: 'User',
        products: 'Products',
        target: 'Target',
        close: 'Chiudi',
        refillNote: 'Nota di riempimento',
        planogramHelpText:
          "Disposizione del planogramma per il posizionamento dei prodotti sugli scaffali dell'armadio durante il riempimento.",
        planogramMissing: 'Non è stato definito un planogramma.',
        planogramImageHelpText:
          'Immagine del planogramma per il piano di riempimento.',
        planogram: 'Planogramma',
        inventoryInfoWarning:
          'Avviso: Il tuo piano di riempimento non è ancora stato completato, puoi controllare la scheda del piano di riempimento per vedere gli articoli mancanti.',
        inventoryInfoSuccess:
          'Congratulazioni, hai raggiunto il tuo piano di riempimento!',
        inventory: 'Inventario',
        screen: 'Schermo',
        shelf: 'Scaffale',
        slot: 'Slot',
        start_calibration: 'Inizia calibrazione',
        end_calibration: 'Termina calibrazione',
        unableToLoadPlanogram: 'Impossibile caricare il planogramma',
        selectSlot:
          'Premi "Inizia" e scegli uno slot qui sotto per iniziare la calibrazione.',
        pressSlotToCalibrate:
          'Seleziona "Avanti" se sei pronto per iniziare la calibrazione per lo slot scelto.',
        confirmSlotEmptied:
          'Assicurati che lo slot sia vuoto. Se ci sono prodotti nello slot, rimuovili prima. Quindi, clicca sul pulsante "Conferma" per verificare che lo slot sia libero.',
        back: 'Indietro',
        next: 'Avanti',
        confirm: 'Sì, conferma',
        cancel: 'Annulla',
        cancelCalibration:
          'Sei sicuro di voler annullare la calibrazione per questo slot?',
        selectProduct: 'Seleziona un prodotto',
        slotNotAssigned:
          "Un prodotto è stato aggiunto al planogramma, ma non è stato ancora assegnato a uno slot specifico nell'armadio.",
        productMismatched:
          'Il prodotto assegnato allo slot selezionato differisce dal prodotto aggiunto al planogramma.',
        productMissing: 'Nessun prodotto è stato ancora assegnato allo slot.',
        searchProduct: 'cerca prodotto...',
        calibrationInProgress:
          'Seleziona uno slot dal planogramma qui sotto per cui desideri addestrare il prodotto',
        placeProducts:
          'Inserisci un minimo di 3 e un massimo di 9 prodotti nello slot selezionato.',
        productMissingInPlanogram:
          'Un prodotto è stato assegnato allo slot selezionato, ma non è elencato nel planogramma.',
        confirmCalibrationProduct:
          'Sei sicuro di aver inserito {{count}} prodotti nello slot selezionato?',
        updateSlotInventory: 'Aggiorna inventario slot',
        updating: 'Aggiornamento in corso...',
      },
      cabinet: {
        label_name: 'Frigo',
        door_lock: 'Fine',
        door_unlock: 'Inizio',
        applying_setting: "Applicazione dell'impostazione",
        filter_instruction:
          'Seleziona se visualizzare solo gli articoli riforniti o tutti gli articoli nella schermata di rifornimento del frigo',
        all_items: 'Tutti gli articoli',
        refilled_items: 'Articoli riforniti',
        refill_question:
          'Contrassegnare come completato il piano di ricarica attivo per questa vetrinetta?',
        refill_warning_question:
          'Il tuo piano di riempimento attivo per questo armadio non è ancora stato completato, vuoi comunque segnarlo come completato?',
      },
      error: {
        forbidden: 'Non sei autorizzato a rifornire questo dispositivo',
        unknown: 'Qualcosa è andato storto...',
        error: 'Errore',
        not_found_plan:
          'Nessun piano di ricarica trovato per questo dispositivo',
        plan_status: 'Impossibile aggiornare lo stato del piano di ricarica',
        cabinetState: "Impossibile recuperare lo stato dell'armadio.",
      },
    },
    es: {
      signin: {
        button: 'Iniciar sesión',
        message: 'Reposición de armario Selfly',
      },
      common: {
        signout: 'Cerrar sesión',
        redirecting: 'Redirigir',
        start_read_qr: 'Empiece leyendo el código QR del dispositivo',
        no_permission_to_replenish_device:
          'No tiene los permisos necesarios para reponer este armario',
        please_wait_for_door_open:
          'Por favor, espere hasta que se abra la puerta...',
        language: 'Seleccionar idioma',
        refill_app: 'Aplicación de reposición',
        plan_help_text:
          'Este es el plan de objetivos que indica la cantidad de productos que deben añadirse o retirarse del armario',
        no_plan: 'No hay ningún plan de reposición activo para este armario',
        yes: 'Sí',
        no: 'No',
        add: 'Añadir',
        remove: 'Eliminar',
        refill: 'Reponer',
        refillPlan: 'Plan de reposición',
        settings: 'Ajustes',
        user: 'Usuario',
        products: 'Productos',
        target: 'Objetivo',
        close: 'Cerrar',
        refillNote: 'Nota de recarga',
        planogramHelpText:
          'Disposición del planograma para la colocación de productos en los estantes del gabinete durante el reabastecimiento.',
        planogramMissing: 'No se ha definido un planograma.',
        planogramImageHelpText:
          'Imagen del planograma para el plan de reposición.',
        planogram: 'Planograma',
        inventoryInfoWarning:
          'Advertencia: Su plan de reposición aún no se ha cumplido, puede verificar la pestaña del plan de reposición para ver los artículos faltantes.',
        inventoryInfoSuccess:
          '¡Felicidades, has cumplido con tu plan de reposición!',
        inventory: 'Inventario',
        screen: 'Pantalla',
        shelf: 'Estante',
        slot: 'Ranura',
        start_calibration: 'Iniciar calibración',
        end_calibration: 'Finalizar calibración',
        unableToLoadPlanogram: 'No se puede cargar el planograma',
        selectSlot:
          'Presione "Iniciar" y elija una ranura a continuación para comenzar la calibración.',
        pressSlotToCalibrate:
          'Seleccione "Siguiente" si está listo para comenzar la calibración para la ranura elegida.',
        confirmSlotEmptied:
          'Asegúrese de que la ranura esté vacía. Si hay productos en la ranura, retírelos primero. Luego, haga clic en el botón "Confirmar" para verificar que la ranura esté vacía.',
        back: 'Atrás',
        next: 'Siguiente',
        confirm: 'Sí, confirmar',
        cancel: 'Cancelar',
        cancelCalibration:
          '¿Está seguro de que desea cancelar la calibración para esta ranura?',
        selectProduct: 'Seleccionar un producto',
        slotNotAssigned:
          'Se ha agregado un producto al planograma, pero aún no se ha asignado a una ranura específica en el gabinete.',
        productMismatched:
          'El producto asignado a la ranura seleccionada difiere del producto agregado al planograma.',
        productMissing: 'Aún no se ha asignado ningún producto a la ranura.',
        searchProduct: 'buscar producto...',
        calibrationInProgress:
          'Seleccione una ranura del planograma a continuación para la que desea entrenar el producto',
        placeProducts:
          'Coloque un mínimo de 3 y un máximo de 9 productos en la ranura seleccionada.',
        productMissingInPlanogram:
          'Se ha asignado un producto a la ranura seleccionada, pero no aparece en el planograma.',
        confirmCalibrationProduct:
          '¿Está seguro de que ha colocado {{count}} productos en la ranura seleccionada?',
        updateSlotInventory: 'Actualizar inventario de ranuras',
        updating: 'Actualizando...',
      },
      cabinet: {
        label_name: 'Armario',
        door_lock: 'Fin',
        door_unlock: 'Inicio',
        applying_setting: 'Aplicando el ajuste',
        filter_instruction:
          'Seleccione si desea mostrar solo los artículos repuestos o todos los artículos en la pantalla de reposición del armario',
        all_items: 'Todos los artículos',
        refilled_items: 'Artículos repuestos',
        refill_question:
          '¿Desea marcar el plan de reposición activo para este armario como completado?',
        refill_warning_question:
          'Su plan de reposición activo para este gabinete aún no se ha cumplido, ¿aún así quiere marcarlo como completado?',
      },
      error: {
        forbidden: 'No tiene permiso para reponer este dispositivo',
        unknown: 'Algo salió mal...',
        error: 'Error',
        not_found_plan:
          'No se ha encontrado ningún plan de reposición para este dispositivo',
        plan_status:
          'No se ha podido actualizar el estado del plan de reposición',
        cabinetState: 'No se pudo obtener el estado del gabinete.',
      },
    },
    de: {
      signin: {
        button: 'Anmelden',
        message: 'Selfly-Schranknachfüllung',
      },
      common: {
        signout: 'Abmelden',
        redirecting: 'Weiterleitung',
        start_read_qr: 'Beginnen Sie mit dem Lesen des Geräte-QR-Codes.',
        no_permission_to_replenish_device:
          'Sie verfügen nicht über die erforderlichen Berechtigungen, um diesen Schrank nachzufüllen.',
        please_wait_for_door_open:
          'Bitte warten Sie, bis die Tür geöffnet wird...',
        language: 'Sprache auswählen',
        refill_app: 'Nachfüll-App',
        plan_help_text:
          'Dies ist der Zielplan, der die Menge der hinzuzufügenden oder zu entnehmenden Produkte im Schrank angibt.',
        no_plan: 'Für diesen Schrank gibt es keinen aktiven Nachfüllplan.',
        yes: 'Ja',
        no: 'Nein',
        add: 'Hinzufügen',
        remove: 'Entfernen',
        refill: 'Nachfüllen',
        refillPlan: 'Nachfüllplan',
        settings: 'Einstellungen',
        user: 'Benutzer',
        products: 'Produkte',
        target: 'Ziel',
        close: 'Schließen',
        refillNote: 'Nachfüllnotiz',
        planogramHelpText:
          'Planogramm-Layout für die Platzierung von Produkten auf den Regalen des Schranks während des Nachfüllens.',
        planogramMissing: 'Kein Planogramm definiert.',
        planogramImageHelpText: 'Planogrammbild für den Nachfüllplan.',
        planogram: 'Planogramm',
        inventoryInfoWarning:
          'Warnung: Ihr Nachfüllplan ist noch nicht erfüllt, Sie können die Nachfüllplan-Registerkarte überprüfen, um die fehlenden Artikel zu sehen.',
        inventoryInfoSuccess:
          'Herzlichen Glückwunsch, Sie haben Ihren Nachfüllplan erreicht!',
        inventory: 'Inventar',
        screen: 'Bildschirm',
        shelf: 'Regal',
        slot: 'Platz',
        start_calibration: 'Kalibrierung starten',
        end_calibration: 'Kalibrierung beenden',
        unableToLoadPlanogram: 'Planogramm kann nicht geladen werden',
        selectSlot:
          'Drücken Sie "Start" und wählen Sie unten einen Steckplatz aus, um die Kalibrierung zu beginnen.',
        pressSlotToCalibrate:
          'Wählen Sie "Weiter", wenn Sie bereit sind, die Kalibrierung für den ausgewählten Steckplatz zu starten.',
        confirmSlotEmptied:
          'Bitte stellen Sie sicher, dass der Steckplatz leer ist. Wenn sich Produkte im Steckplatz befinden, entfernen Sie diese zuerst. Klicken Sie dann auf die Schaltfläche "Bestätigen", um zu überprüfen, ob der Steckplatz leer ist.',
        back: 'Zurück',
        next: 'Weiter',
        confirm: 'Ja, bestätigen',
        cancel: 'Abbrechen',
        cancelCalibration:
          'Sind Sie sicher, dass Sie die Kalibrierung für diesen Steckplatz abbrechen möchten?',
        selectProduct: 'Produkt auswählen',
        slotNotAssigned:
          'Ein Produkt wurde zum Planogramm hinzugefügt, aber es wurde noch keinem bestimmten Steckplatz im Schrank zugewiesen.',
        productMismatched:
          'Das dem ausgewählten Steckplatz zugewiesene Produkt unterscheidet sich von dem zum Planogramm hinzugefügten Produkt.',
        productMissing: 'Dem Steckplatz wurde noch kein Produkt zugewiesen.',
        searchProduct: 'Produkt suchen...',
        calibrationInProgress:
          'Bitte wählen Sie unten einen Steckplatz aus dem Planogramm aus, für den Sie das Produkt trainieren möchten',
        placeProducts:
          'Bitte platzieren Sie mindestens 3 und maximal 9 Produkte im ausgewählten Steckplatz.',
        productMissingInPlanogram:
          'Dem ausgewählten Steckplatz wurde ein Produkt zugewiesen, das jedoch nicht im Planogramm aufgeführt ist.',
        confirmCalibrationProduct:
          'Sind Sie sicher, dass Sie {{count}} Produkte im ausgewählten Steckplatz platziert haben?',
        updateSlotInventory: 'Steckplatzinventar aktualisieren',
        updating: 'Wird aktualisiert...',
      },
      cabinet: {
        label_name: 'Schrank',
        door_lock: 'Ende',
        door_unlock: 'Start',
        applying_setting: 'Einstellung anwenden',
        filter_instruction:
          'Wählen Sie aus, ob nur nachgefüllte Artikel oder alle Artikel auf dem Nachfüllbildschirm des Schranks angezeigt werden sollen.',
        all_items: 'Alle Artikel',
        refilled_items: 'Nachgefüllte Artikel',
        refill_question:
          'Möchten Sie den aktiven Nachfüllplan für diesen Schrank als abgeschlossen markieren?',
        refill_warning_question:
          'Ihr aktiver Nachfüllplan für diesen Schrank ist noch nicht erfüllt, möchten Sie ihn trotzdem als abgeschlossen markieren?',
      },
      error: {
        forbidden:
          'Sie verfügen nicht über die Berechtigung, dieses Gerät nachzufüllen.',
        unknown: 'Irgendetwas ist schief gelaufen...',
        error: 'Fehler',
        not_found_plan: 'Für dieses Gerät wurde kein Nachfüllplan gefunden',
        plan_status: 'Der Nachfüllplan konnte nicht aktualisiert werden.',
        cabinetState: 'Der Status des Schranks konnte nicht abgerufen werden.',
      },
    },
    fr: {
      signin: {
        button: 'Connexion',
        message: "Réapprovisionnement d'armoire Selfly",
      },
      common: {
        signout: 'Déconnexion',
        redirecting: 'Redirection',
        start_read_qr: "Commencez par lire le code QR de l'appareil",
        no_permission_to_replenish_device:
          "Vous n'avez pas les autorisations requises pour réapprovisionner cette armoire",
        please_wait_for_door_open:
          "Veuillez patienter jusqu'à ce que la porte soit ouverte...",
        language: 'Sélectionner la langue',
        refill_app: 'Application de réapprovisionnement',
        plan_help_text:
          "Il s'agit du plan cible qui indique la quantité de produits à ajouter ou à retirer de l'armoire",
        no_plan:
          "Il n'y a pas de plan de réapprovisionnement actif pour cette armoire",
        yes: 'Oui',
        no: 'Non',
        add: 'Ajouter',
        remove: 'Retirer',
        refill: 'Réapprovisionner',
        refillPlan: 'Plan de réapprovisionnement',
        settings: 'Réglages',
        user: 'Utilisateur',
        products: 'Produits',
        target: 'Cible',
        close: 'Fermer',
        refillNote: 'Note de remplissage',
        planogramHelpText:
          'Disposition du planogramme pour le placement des produits sur les étagères du cabinet lors du remplissage.',
        planogramMissing: "Aucun planogramme n'a été défini.",
        planogramImageHelpText:
          'Image du planogramme pour le plan de remplissage.',
        planogram: 'Planogramme',
        inventoryInfoWarning:
          "Avertissement : Votre plan de remplissage n'est pas encore respecté, vous pouvez vérifier l'onglet plan de remplissage pour voir les articles manquants.",
        inventoryInfoSuccess:
          'Félicitations, vous avez atteint votre plan de remplissage !',
        inventory: 'Inventaire',
        screen: 'Écran',
        shelf: 'Étagère',
        slot: 'Emplacement',
        start_calibration: 'Démarrer la calibration',
        end_calibration: 'Terminer la calibration',
        unableToLoadPlanogram: 'Impossible de charger le planogramme',
        selectSlot:
          'Appuyez sur "Démarrer" et choisissez un emplacement ci-dessous pour commencer la calibration.',
        pressSlotToCalibrate:
          'Sélectionnez "Suivant" si vous êtes prêt à commencer la calibration pour l\'emplacement choisi.',
        confirmSlotEmptied:
          "Veuillez vous assurer que l'emplacement est vide. Si des produits se trouvent dans l'emplacement, retirez-les d'abord. Ensuite, cliquez sur le bouton \"Confirmer\" pour vérifier que l'emplacement est vide.",
        back: 'Retour',
        next: 'Suivant',
        confirm: 'Oui, confirmer',
        cancel: 'Annuler',
        cancelCalibration:
          'Êtes-vous sûr de vouloir annuler la calibration pour cet emplacement ?',
        selectProduct: 'Sélectionner un produit',
        slotNotAssigned:
          "Un produit a été ajouté au planogramme, mais il n'a pas encore été attribué à un emplacement spécifique dans l'armoire.",
        productMismatched:
          "Le produit attribué à l'emplacement sélectionné diffère du produit ajouté au planogramme.",
        productMissing:
          "Aucun produit n'a encore été attribué à l'emplacement.",
        searchProduct: 'rechercher un produit...',
        calibrationInProgress:
          'Veuillez sélectionner un emplacement dans le planogramme ci-dessous pour lequel vous souhaitez entraîner le produit',
        placeProducts:
          "Veuillez placer un minimum de 3 et un maximum de 9 produits dans l'emplacement sélectionné.",
        productMissingInPlanogram:
          "Un produit a été attribué à l'emplacement sélectionné mais n'est pas répertorié dans le planogramme.",
        confirmCalibrationProduct:
          "Êtes-vous sûr d'avoir placé {{count}} produits dans l'emplacement sélectionné ?",
        updateSlotInventory: "Mettre à jour l'inventaire des emplacements",
        updating: 'Mise à jour...',
      },
      cabinet: {
        label_name: 'Armoire',
        door_lock: 'Fin',
        door_unlock: 'Début',
        applying_setting: 'Application du paramètre',
        filter_instruction:
          "Choisissez d'afficher uniquement les articles réapprovisionnés ou tous les articles sur l'écran de réapprovisionnement de l'armoire",
        all_items: 'Tous les articles',
        refilled_items: 'Articles réapprovisionnés',
        refill_question:
          'Voulez-vous marquer le plan de réapprovisionnement actif de cette armoire comme étant terminé?',
        refill_warning_question:
          "Votre plan de remplissage actif pour ce cabinet n'est pas encore atteint, souhaitez-vous tout de même le marquer comme terminé ?",
      },
      error: {
        forbidden: "Vous n'êtes pas autorisé à réapprovisionner cet appareil",
        unknown: "Une erreur s'est produite...",
        error: 'Erreur',
        not_found_plan:
          "Aucun plan de réapprovisionnement n'a été trouvé pour ce dispositif",
        plan_status:
          "Le statut du plan de réapprovisionnement n'a pas pu être mis à jour",
        cabinetState: "Impossible de récupérer l'état de l'armoire.",
      },
    },
    hu: {
      signin: {
        button: 'Bejelentkezés',
        message: 'Selfly szekrény újratöltés',
      },
      common: {
        signout: 'Kijelentkezés',
        redirecting: 'Átirányítás',
        start_read_qr: 'Kezdje az eszköz QR-kódjának olvasásával',
        no_permission_to_replenish_device:
          'Nem rendelkezik a szekrény újratöltéséhez szükséges engedélyekkel',
        please_wait_for_door_open: 'Várjon, amíg az ajtó kinyílik...',
        language: 'Nyelv kiválasztása',
        refill_app: 'Alkalmazás feltöltése',
        plan_help_text:
          'Ez az a célterv, amely jelzi a szekrényhez hozzáadandó vagy a szekrényből eltávolítandó termékek mennyiségét',
        no_plan: 'Ehhez a szekrényhez nincs aktív újratöltési terv',
        yes: 'Igen',
        no: 'Nem',
        add: 'Hozzáadás',
        remove: 'Eltávolítás',
        refill: 'Újratöltés',
        refillPlan: 'Újratöltési terv',
        settings: 'Beállítások',
        user: 'Felhasználó',
        products: 'Termékek',
        target: 'Cél',
        close: 'Bezárás',
        refillNote: 'Utántöltési megjegyzés',
        planogramHelpText:
          'Stratégiai elrendezés a termékek szekrény polcain való elhelyezéséhez az újratöltés során.',
        planogramMissing: 'Nem lett meghatározva planogram.',
        planogramImageHelpText: 'Planogram kép az újratöltési tervhez.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Figyelem: Az újratöltési terved még nincs teljesítve, az újratöltési terv fülön ellenőrizheted a hiányzó tételeket.',
        inventoryInfoSuccess: 'Gratulálunk, elérted az újratöltési tervedet!',
        inventory: 'Készlet',
        screen: 'Képernyő',
        shelf: 'Polc',
        slot: 'Hely',
        start_calibration: 'Kalibrálás indítása',
        end_calibration: 'Kalibrálás befejezése',
        unableToLoadPlanogram: 'Nem sikerült betölteni a planogramot',
        selectSlot:
          'Nyomja meg a "Start" gombot, és válasszon egy helyet alább a kalibrálás megkezdéséhez.',
        pressSlotToCalibrate:
          'Válassza a "Tovább" lehetőséget, ha készen áll a kalibrálás megkezdésére a kiválasztott helyen.',
        confirmSlotEmptied:
          'Kérjük, ellenőrizze, hogy a hely üres-e. Ha bármilyen termék van a helyen, először távolítsa el őket. Ezután kattintson a "Megerősítés" gombra, hogy ellenőrizze, hogy a hely üres.',
        back: 'Vissza',
        next: 'Tovább',
        confirm: 'Igen, megerősít',
        cancel: 'Mégse',
        cancelCalibration:
          'Biztosan meg szeretné szakítani a kalibrálást ezen a helyen?',
        selectProduct: 'Válasszon terméket',
        slotNotAssigned:
          'A planogramhoz termék lett hozzáadva, de még nem lett hozzárendelve a szekrény adott helyéhez.',
        productMismatched:
          'A kiválasztott helyhez rendelt termék eltér a planogramhoz hozzáadott terméktől.',
        productMissing: 'A helyhez még nincs termék hozzárendelve.',
        searchProduct: 'termék keresése...',
        calibrationInProgress:
          'Kérjük, válasszon egy helyet az alábbi planogramból, amelyhez a terméket tanítani szeretné',
        placeProducts:
          'Kérjük, helyezzen el legalább 3 és legfeljebb 9 terméket a kiválasztott helyen.',
        productMissingInPlanogram:
          'A kiválasztott helyhez termék lett hozzárendelve, de nem szerepel a planogramban.',
        confirmCalibrationProduct:
          'Biztosan elhelyezett {{count}} terméket a kiválasztott helyen?',
        updateSlotInventory: 'Helyfoglaltság frissítése',
        updating: 'Frissítés alatt...',
      },
      cabinet: {
        label_name: 'Szekrény',
        door_lock: 'Befejezés',
        door_unlock: 'Indítás',
        applying_setting: 'Beállítás alkalmazása',
        filter_instruction:
          'Válassza ki, hogy csak az újratöltött tételeket vagy az összes tételt szeretné megjeleníteni a szekrény újratöltési képernyőjén',
        all_items: 'Minden tétel',
        refilled_items: 'Újratöltött tételek',
        refill_question:
          'Szeretné befejezettként megjelölni a szekrény aktív újratöltési tervét?',
        refill_warning_question:
          'Az aktív újratöltési terved ennél a szekrénynél még nincs teljesítve, mégis szeretnéd késznek jelölni?',
      },
      error: {
        forbidden: 'Nincs jogosultsága az eszköz újratöltéséhez',
        unknown: 'Hiba történt...',
        error: 'Hiba',
        not_found_plan: 'Nem található újratöltési terv ehhez az eszközhöz',
        plan_status: 'Az újratöltési terv állapota nem frissíthető',
        cabinetState: 'Nem sikerült lekérdezni a szekrény állapotát.',
      },
    },
    lv: {
      signin: {
        button: 'Pierakstīties',
        message: 'Selfly vitrīnas uzpilde',
      },
      common: {
        signout: 'Izrakstīties',
        redirecting: 'Pārvirzīšana',
        start_read_qr: 'Sākt, nolasot ierīces QR kodu',
        no_permission_to_replenish_device:
          'Jums nav šīs vitrīnas uzpildīšanai nepieciešamo atļauju',
        please_wait_for_door_open: 'Lūdzu, uzgaidiet līdz durvju atvēršanai...',
        language: 'Atlasīt valodu',
        refill_app: 'Uzpildes lietotne',
        plan_help_text:
          'Šis ir mērķa plāns, kas norāda vitrīnā pievienojamo vai no tās izņemamo produktu daudzumu',
        no_plan: 'Šai vitrīnai nav aktīva uzpildes plāna',
        yes: 'Jā',
        no: 'Nē',
        add: 'Pievienot',
        remove: 'Noņemt',
        refill: 'Uzpildīt',
        refillPlan: 'Uzpildes plāns',
        settings: 'Iestatījumi',
        user: 'Lietotājs',
        products: 'Produkti',
        target: 'Mērķis',
        close: 'Aizvērt',
        refillNote: 'Uzpildes piezīme',
        planogramHelpText:
          'Produktu izvietošanas plānojums skapja plauktos papildināšanas laikā.',
        planogramMissing: 'Nav definēts plānoga plānojums.',
        planogramImageHelpText: 'Plānograma attēls papildināšanas plānam.',
        planogram: 'Planograms',
        inventoryInfoWarning:
          'Brīdinājums: Jūsu papildināšanas plāns vēl nav izpildīts, varat pārbaudīt papildināšanas plāna cilni, lai redzētu trūkstošos priekšmetus.',
        inventoryInfoSuccess:
          'Apsveicam, esat sasniedzis savu papildināšanas plānu!',
        inventory: 'Krājumi',
        screen: 'Ekrāns',
        shelf: 'Plaukts',
        slot: 'Vieta',
        start_calibration: 'Sākt kalibrēšanu',
        end_calibration: 'Beigt kalibrēšanu',
        unableToLoadPlanogram: 'Nevar ielādēt planogrammu',
        selectSlot:
          'Nospiediet "Sākt" un izvēlieties slotu zemāk, lai sāktu kalibrēšanu.',
        pressSlotToCalibrate:
          'Izvēlieties "Tālāk", ja esat gatavs sākt kalibrēšanu izvēlētajam slotam.',
        confirmSlotEmptied:
          'Lūdzu, pārliecinieties, vai slots ir tukšs. Ja slotā ir kādi produkti, vispirms tos noņemiet. Pēc tam noklikšķiniet uz pogas "Apstiprināt", lai apstiprinātu, ka slots ir tukšs.',
        back: 'Atpakaļ',
        next: 'Tālāk',
        confirm: 'Jā, apstiprināt',
        cancel: 'Atcelt',
        cancelCalibration: 'Vai tiešām vēlaties atcelt kalibrēšanu šim slotam?',
        selectProduct: 'Izvēlieties produktu',
        slotNotAssigned:
          'Planogrammai ir pievienots produkts, bet tas vēl nav piešķirts konkrētam slotam skapī.',
        productMismatched:
          'Izvēlētajam slotam piešķirtais produkts atšķiras no planogrammai pievienotā produkta.',
        productMissing: 'Slotam vēl nav piešķirts produkts.',
        searchProduct: 'meklēt produktu...',
        calibrationInProgress:
          'Lūdzu, izvēlieties slotu no planogrammas zemāk, kuram vēlaties apmācīt produktu',
        placeProducts:
          'Lūdzu, ievietojiet izvēlētajā slotā vismaz 3 un ne vairāk kā 9 produktus.',
        productMissingInPlanogram:
          'Izvēlētajam slotam ir piešķirts produkts, bet tas nav norādīts planogrammā.',
        confirmCalibrationProduct:
          'Vai tiešām esat ievietojis {{count}} produktus izvēlētajā slotā?',
        updateSlotInventory: 'Atjaunināt slota inventāru',
        updating: 'Notiek atjaunināšana...',
      },
      cabinet: {
        label_name: 'Vitrīna',
        door_lock: 'Beigas',
        door_unlock: 'Sākums',
        applying_setting: 'Iestatījuma lietošana',
        filter_instruction:
          'Atlasiet, vai vitrīnas uzpildes ekrānā parādīt tikai uzpildītos vai visus vienumus',
        all_items: 'Visi vienumi',
        refilled_items: 'Uzpildītie vienumi',
        refill_question:
          'Vai vēlaties atzīmēt aktīvo uzpildes plānu šai vitrīnai kā pabeigtu?',
        refill_warning_question:
          'Jūsu aktīvais papildināšanas plāns šim skapim vēl nav sasniegts. Vai tomēr vēlaties to atzīmēt kā pabeigtu?',
      },
      error: {
        forbidden: 'Jums nav atļaujas šīs ierīces uzpildīšanai',
        unknown: 'Kaut kas neizdevās...',
        error: 'Kļūda',
        not_found_plan: 'Šai ierīcei nav atrasts uzpildes plāns',
        plan_status: 'Uzpildes plāna statusu nevarēja atjaunināt',
        cabinetState: 'Neizdevās iegūt skapja statusu.',
      },
    },
    et: {
      signin: {
        button: 'Sisene',
        message: 'Selfly kapi taastäitmine',
      },
      common: {
        signout: 'Välju',
        redirecting: 'Ümbersuunamine',
        start_read_qr: 'Alusta seadme QR-koodi lugemisest',
        no_permission_to_replenish_device:
          'Teil pole selle kapi taastäitmiseks vajalikke õigusi',
        please_wait_for_door_open: 'Oodake, kuni uks avaneb...',
        language: 'Valige keel',
        refill_app: 'Täitmisrakendus',
        plan_help_text:
          'See on sihtplaan, mis näitab kappi lisatavate või sealt eemaldatavate toodete kogust',
        no_plan: 'Sellel kapil puudub aktiivne täitmisplaan',
        yes: 'Jah',
        no: 'Ei',
        add: 'Lisa',
        remove: 'Eemalda',
        refill: 'Täitmine',
        refillPlan: 'Täitmisplaan',
        settings: 'Seaded',
        user: 'Kasutaja',
        products: 'Tooted',
        target: 'Siht',
        close: 'Sulge',
        refillNote: 'Täiendamise märkus',
        planogramHelpText:
          'Planeering toodete paigutamiseks kapi riiulitele täitmise ajal.',
        planogramMissing: 'Plaani ei ole määratletud.',
        planogramImageHelpText: 'Planeeringu pilt täitmisplaani jaoks.',
        planogram: 'Plaanogramm',
        inventoryInfoWarning:
          'Hoiatus: Teie täitmisplaan pole veel täidetud, puuduvate esemete nägemiseks saate vaadata täitmisplaani vahekaarti.',
        inventoryInfoSuccess: 'Palju õnne, olete oma täitmisplaani saavutanud!',
        inventory: 'Inventuur',
        screen: 'Ekraan',
        shelf: 'Riiul',
        slot: 'Pesa',
        start_calibration: 'Alusta kalibreerimist',
        end_calibration: 'Lõpeta kalibreerimine',
        unableToLoadPlanogram: 'Planogrammi ei saa laadida',
        selectSlot:
          'Vajutage "Alusta" ja valige allpool pesa, et alustada kalibreerimist.',
        pressSlotToCalibrate:
          'Valige "Järgmine", kui olete valmis alustama kalibreerimist valitud pesa jaoks.',
        confirmSlotEmptied:
          'Palun veenduge, et pesa on tühi. Kui pesas on tooteid, eemaldage need esmalt. Seejärel klõpsake nuppu "Kinnita", et kontrollida, kas pesa on tühi.',
        back: 'Tagasi',
        next: 'Järgmine',
        confirm: 'Jah, kinnita',
        cancel: 'Tühista',
        cancelCalibration:
          'Kas olete kindel, et soovite selle pesa kalibreerimise tühistada?',
        selectProduct: 'Valige toode',
        slotNotAssigned:
          'Planogrammile on lisatud toode, kuid seda pole veel kapi kindlale pesale määratud.',
        productMismatched:
          'Valitud pesale määratud toode erineb planogrammile lisatud tootest.',
        productMissing: 'Pesale pole veel toodet määratud.',
        searchProduct: 'otsi toodet...',
        calibrationInProgress:
          'Palun valige allolevalt planogrammilt pesa, mille jaoks soovite toodet treenida',
        placeProducts:
          'Palun asetage valitud pessa vähemalt 3 ja maksimaalselt 9 toodet.',
        productMissingInPlanogram:
          'Valitud pesale on määratud toode, kuid seda pole planogrammis loetletud.',
        confirmCalibrationProduct:
          'Kas olete kindel, et olete valitud pessa asetanud {{count}} toodet?',
        updateSlotInventory: 'Värskenda pesa laoseisu',
        updating: 'Värskendamine...',
      },
      cabinet: {
        label_name: 'Kapp',
        door_lock: 'Lõpp',
        door_unlock: 'Algus',
        applying_setting: 'Seadistuse rakendamine',
        filter_instruction:
          'Valige, kas kuvada kapi laadimisekraanil ainult taastäidetud või kõik tooted.',
        all_items: 'Kõik tooted',
        refilled_items: 'Taastäidetud tooted',
        refill_question:
          'Kas soovite märkida selle kapi aktiivse täitmisplaani lõpetatuks?',
        refill_warning_question:
          'Teie aktiivne täitmisplaan selle kapi jaoks pole veel täidetud, kas soovite selle siiski valmis märkida?',
      },
      error: {
        forbidden: 'Teil pole luba seda seadet taastäita',
        unknown: 'Midagi läks valesti...',
        error: 'Viga',
        not_found_plan: 'Selle seadme jaoks täitmisplaani ei leitud',
        plan_status: 'Täitmisplaani olekut ei õnnestunud muuta',
        cabinetState: 'Kapi olekut ei saanud tuua.',
      },
    },
    ro: {
      signin: {
        button: 'Conectare',
        message: 'Reumplere dispozitiv Selfly',
      },
      common: {
        signout: 'Deconectare',
        redirecting: 'Se redirecționează',
        start_read_qr: 'Începeți prin a citi codul QR al dispozitivului',
        no_permission_to_replenish_device:
          'Nu aveți permisiunile necesare pentru a reumple acest dispozitiv',
        please_wait_for_door_open: 'Așteptați până se deschide ușa...',
        language: 'Selectați limba',
        refill_app: 'Aplicație de reumplere',
        plan_help_text:
          'Acesta este planul țintă care indică cantitatea de produse ce urmează să fie adăugate sau eliminate din vitrină',
        no_plan: 'Nu există un plan de reumplere activ pentru această vitrină',
        yes: 'Da',
        no: 'Nu',
        add: 'Adăugați',
        remove: 'Eliminați',
        refill: 'Reumpleți',
        refillPlan: 'Plan de reumplere',
        settings: 'Setări',
        user: 'Utilizator',
        products: 'Produse',
        target: 'Ţintă',
        close: 'Închide',
        refillNote: 'Notă de reaprovizionare',
        planogramHelpText:
          'Aspectul planogramei pentru plasarea produselor pe rafturile dulapului în timpul reumplerii.',
        planogramMissing: 'Nu a fost definită nicio planogramă.',
        planogramImageHelpText:
          'Imaginea planogramei pentru planul de reumplere.',
        planogram: 'Planogramă',
        inventoryInfoWarning:
          'Atenție: Planul dvs. de reumplere nu este încă îndeplinit, puteți verifica fila planului de reumplere pentru a vedea articolele lipsă.',
        inventoryInfoSuccess:
          'Felicitări, ați realizat planul dvs. de reumplere!',
        inventory: 'Inventar',
        screen: 'Ecran',
        shelf: 'Raft',
        slot: 'Slot',
        start_calibration: 'Începe calibrarea',
        end_calibration: 'Termină calibrarea',
        unableToLoadPlanogram: 'Nu se poate încărca planograma',
        selectSlot:
          'Apăsați "Start" și alegeți un slot de mai jos pentru a începe calibrarea.',
        pressSlotToCalibrate:
          'Selectați "Următorul" dacă sunteți gata să începeți calibrarea pentru slotul ales.',
        confirmSlotEmptied:
          'Vă rugăm să vă asigurați că slotul este gol. Dacă există produse în slot, scoateți-le mai întâi. Apoi, faceți clic pe butonul "Confirmare" pentru a verifica dacă slotul este clar.',
        back: 'Înapoi',
        next: 'Următorul',
        confirm: 'Da, confirmă',
        cancel: 'Anulează',
        cancelCalibration:
          'Sigur doriți să anulați calibrarea pentru acest slot?',
        selectProduct: 'Selectați un produs',
        slotNotAssigned:
          'Un produs a fost adăugat la planogramă, dar nu a fost încă atribuit unui slot specific din dulap.',
        productMismatched:
          'Produsul atribuit slotului selectat diferă de produsul adăugat la planogramă.',
        productMissing: 'Niciun produs nu a fost încă atribuit slotului.',
        searchProduct: 'caută produs...',
        calibrationInProgress:
          'Vă rugăm să selectați un slot din planograma de mai jos pentru care doriți să antrenați produsul',
        placeProducts:
          'Vă rugăm să puneți minimum 3 și maximum 9 produse în slotul selectat.',
        productMissingInPlanogram:
          'Un produs a fost atribuit slotului selectat, dar nu este listat în planogramă.',
        confirmCalibrationProduct:
          'Sigur ați pus {{count}} produse în slotul selectat?',
        updateSlotInventory: 'Actualizează inventarul slotului',
        updating: 'Actualizare...',
      },
      cabinet: {
        label_name: 'Dispozitiv',
        door_lock: 'Sfârșit',
        door_unlock: 'Început',
        applying_setting: 'Se aplică setarea',
        filter_instruction:
          'Selectați dacă afișați numai articolele reumplute sau toate articolele pe ecranul de reumplere al dispozitivului',
        all_items: 'Toate articolele',
        refilled_items: 'Articole reumplute',
        refill_question:
          'Doriți să marcați planul de reumplere activ pentru această vitrină ca finalizat?',
        refill_warning_question:
          'Planul dvs. activ de reumplere pentru acest dulap nu a fost încă realizat. Doriți totuși să îl marcați ca finalizat?',
      },
      error: {
        forbidden: 'Nu aveți permisiunea de a reumple acest dispozitiv',
        unknown: 'A apărut o eroare...',
        error: 'Eroare',
        not_found_plan:
          'Nu a fost găsit niciun plan de reumplere pentru acest dispozitiv',
        plan_status: 'Starea planului de reumplere nu a putut fi actualizată',
        cabinetState: 'Nu s-a putut prelua starea dulapului.',
      },
    },
    sv: {
      signin: {
        button: 'Logga in',
        message: 'Selfly skåppåfyllning',
      },
      common: {
        signout: 'Logga ut',
        redirecting: 'Omdirigerar',
        start_read_qr: 'Börja med att läsa enhetens QR-kod',
        no_permission_to_replenish_device:
          'Du har inte behörigheter för att fylla på detta skåp',
        please_wait_for_door_open: 'Vänta tills dörren öppnas...',
        language: 'Välj språk',
        refill_app: 'Påfyllningsapp',
        plan_help_text:
          'Detta är målplanen som anger mängden produkter som ska läggas till eller tas bort från skåpet',
        no_plan: 'Det finns ingen aktiv påfyllningsplan för detta skåp',
        yes: 'Ja',
        no: 'Nej',
        add: 'Lägg till',
        remove: 'Ta bort',
        refill: 'Fyll på',
        refillPlan: 'Påfyllningsplan',
        settings: 'Inställningar',
        user: 'Användare',
        products: 'Produkter',
        target: 'Mål',
        close: 'Stäng',
        refillNote: 'Påfyllningsnotering',
        planogramHelpText:
          'Planogramlayout för placering av produkter på skåpets hyllor under påfyllning.',
        planogramMissing: 'Ingen planogram har definierats.',
        planogramImageHelpText: 'Planogrambild för påfyllningsplanen.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Varning: Din påfyllningsplan har ännu inte uppfyllts, du kan kontrollera fliken för påfyllningsplanen för att se de saknade artiklarna.',
        inventoryInfoSuccess: 'Grattis, du har uppnått din påfyllningsplan!',
        inventory: 'Lager',
        screen: 'Skärm',
        shelf: 'Hylla',
        slot: 'Plats',
        start_calibration: 'Starta kalibrering',
        end_calibration: 'Avsluta kalibrering',
        unableToLoadPlanogram: 'Kan inte ladda planogram',
        selectSlot:
          'Tryck på "Start" och välj en plats nedan för att börja kalibreringen.',
        pressSlotToCalibrate:
          'Välj "Nästa" om du är redo att starta kalibreringen för den valda platsen.',
        confirmSlotEmptied:
          'Se till att platsen är tom. Om det finns produkter i platsen, ta bort dem först. Klicka sedan på "Bekräfta"-knappen för att verifiera att platsen är tom.',
        back: 'Tillbaka',
        next: 'Nästa',
        confirm: 'Ja, bekräfta',
        cancel: 'Avbryt',
        cancelCalibration:
          'Är du säker på att du vill avbryta kalibreringen för denna plats?',
        selectProduct: 'Välj en produkt',
        slotNotAssigned:
          'En produkt har lagts till i planogrammet, men den har ännu inte tilldelats en specifik plats i skåpet.',
        productMismatched:
          'Produkten som tilldelats den valda platsen skiljer sig från produkten som lagts till i planogrammet.',
        productMissing: 'Ingen produkt har tilldelats platsen ännu.',
        searchProduct: 'sök produkt...',
        calibrationInProgress:
          'Välj en plats från planogrammet nedan som du vill träna produkten för',
        placeProducts:
          'Placera minst 3 och högst 9 produkter i den valda platsen.',
        productMissingInPlanogram:
          'En produkt har tilldelats den valda platsen men finns inte med i planogrammet.',
        confirmCalibrationProduct:
          'Är du säker på att du har placerat {{count}} produkter i den valda platsen?',
        updateSlotInventory: 'Uppdatera platsinventering',
        updating: 'Uppdaterar...',
      },
      cabinet: {
        label_name: 'Skåp',
        door_lock: 'Avsluta',
        door_unlock: 'Starta',
        applying_setting: 'Tillämpar inställningar',
        filter_instruction:
          'Välj om du bara vill visa påfyllda artiklar eller alla artiklar på skåpets påfyllningsskärm',
        all_items: 'Alla artiklar',
        refilled_items: 'Påfyllda artiklar',
        refill_question:
          'Vill du markera den aktiva påfyllningsplanen för detta skåp som färdig?',
        refill_warning_question:
          'Din aktiva påfyllningsplan för detta skåp har ännu inte uppnåtts. Vill du ändå markera den som slutförd?',
      },
      error: {
        forbidden: 'Du har inte behörighet att fylla på den här enheten',
        unknown: 'Något gick fel...',
        error: 'Fel',
        not_found_plan: 'Ingen påfyllningsplan hittades för den här enheten',
        plan_status: 'Status för påfyllningsplan kunde inte uppdateras',
        cabinetState: 'Kunde inte hämta skåpets status.',
      },
    },
    'de-CH': {
      signin: {
        button: 'Anmelden',
        message: 'Selfly-Schranknachfüllung',
      },
      common: {
        signout: 'Abmelden',
        redirecting: 'Weiterleitung',
        start_read_qr: 'Beginnen Sie mit dem Lesen des Geräte-QR-Codes.',
        no_permission_to_replenish_device:
          'Sie verfügen nicht über die erforderlichen Berechtigungen, um diesen Schrank nachzufüllen.',
        please_wait_for_door_open:
          'Bitte warten Sie, bis die Tür geöffnet wird...',
        language: 'Sprache auswählen',
        refill_app: 'Nachfüll-App',
        plan_help_text:
          'Dies ist der Zielplan, der die Menge der hinzuzufügenden oder zu entnehmenden Produkte im Schrank angibt.',
        no_plan: 'Für diesen Schrank gibt es keinen aktiven Nachfüllplan.',
        yes: 'Ja',
        no: 'Nein',
        add: 'Hinzufügen',
        remove: 'Entfernen',
        refill: 'Nachfüllen',
        refillPlan: 'Nachfüllplan',
        settings: 'Einstellungen',
        user: 'Benutzer',
        products: 'Produkte',
        target: 'Ziel',
        close: 'Schliessen',
        refillNote: 'Nachfüllnotiz',
        planogramHelpText:
          'Planogramm-Layout für die Platzierung von Produkten auf den Regalen des Schranks während des Nachfüllens.',
        planogramMissing: 'Kein Planogramm definiert.',
        planogramImageHelpText: 'Planogrammbild für den Nachfüllplan.',
        planogram: 'Planogramm',
        inventoryInfoWarning:
          'Warnung: Ihr Nachfüllplan ist noch nicht erfüllt, Sie können die Nachfüllplan-Registerkarte überprüfen, um die fehlenden Artikel zu sehen.',
        inventoryInfoSuccess:
          'Herzlichen Glückwunsch, Sie haben Ihren Nachfüllplan erreicht!',
        inventory: 'Inventar',
        screen: 'Bildschirm',
        shelf: 'Regal',
        slot: 'Platz',
        start_calibration: 'Kalibrierung starten',
        end_calibration: 'Kalibrierung beenden',
        unableToLoadPlanogram: 'Planogramm kann nicht geladen werden',
        selectSlot:
          'Drücken Sie "Start" und wählen Sie unten einen Steckplatz aus, um die Kalibrierung zu beginnen.',
        pressSlotToCalibrate:
          'Wählen Sie "Weiter", wenn Sie bereit sind, die Kalibrierung für den ausgewählten Steckplatz zu starten.',
        confirmSlotEmptied:
          'Bitte stellen Sie sicher, dass der Steckplatz leer ist. Wenn sich Produkte im Steckplatz befinden, entfernen Sie diese zuerst. Klicken Sie dann auf die Schaltfläche "Bestätigen", um zu überprüfen, ob der Steckplatz leer ist.',
        back: 'Zurück',
        next: 'Weiter',
        confirm: 'Ja, bestätigen',
        cancel: 'Abbrechen',
        cancelCalibration:
          'Sind Sie sicher, dass Sie die Kalibrierung für diesen Steckplatz abbrechen möchten?',
        selectProduct: 'Produkt auswählen',
        slotNotAssigned:
          'Ein Produkt wurde zum Planogramm hinzugefügt, aber es wurde noch keinem bestimmten Steckplatz im Schrank zugewiesen.',
        productMismatched:
          'Das dem ausgewählten Steckplatz zugewiesene Produkt unterscheidet sich von dem zum Planogramm hinzugefügten Produkt.',
        productMissing: 'Dem Steckplatz wurde noch kein Produkt zugewiesen.',
        searchProduct: 'Produkt suchen...',
        calibrationInProgress:
          'Bitte wählen Sie unten einen Steckplatz aus dem Planogramm aus, für den Sie das Produkt trainieren möchten',
        placeProducts:
          'Bitte platzieren Sie mindestens 3 und maximal 9 Produkte im ausgewählten Steckplatz.',
        productMissingInPlanogram:
          'Dem ausgewählten Steckplatz wurde ein Produkt zugewiesen, das jedoch nicht im Planogramm aufgeführt ist.',
        confirmCalibrationProduct:
          'Sind Sie sicher, dass Sie {{count}} Produkte im ausgewählten Steckplatz platziert haben?',
        updateSlotInventory: 'Steckplatzinventar aktualisieren',
        updating: 'Wird aktualisiert...',
      },
      cabinet: {
        label_name: 'Schrank',
        door_lock: 'Ende',
        door_unlock: 'Start',
        applying_setting: 'Einstellung anwenden',
        filter_instruction:
          'Wählen Sie aus, ob nur nachgefüllte Artikel oder alle Artikel auf dem Nachfüllbildschirm des Schranks angezeigt werden sollen.',
        all_items: 'Alle Artikel',
        refilled_items: 'Nachgefüllte Artikel',
        refill_question:
          'Möchten Sie den aktiven Nachfüllplan für diesen Schrank als abgeschlossen markieren?',
        refill_warning_question:
          'Ihr aktiver Nachfüllplan für diesen Schrank ist noch nicht erfüllt, möchten Sie ihn trotzdem als abgeschlossen markieren?',
      },
      error: {
        forbidden:
          'Sie verfügen nicht über die Berechtigung, dieses Gerät nachzufüllen.',
        unknown: 'Irgendetwas ist schief gelaufen...',
        error: 'Fehler',
        not_found_plan: 'Für dieses Gerät wurde kein Nachfüllplan gefunden',
        plan_status: 'Der Nachfüllplan konnte nicht aktualisiert werden.',
        cabinetState: 'Der Status des Schranks konnte nicht abgerufen werden.',
      },
    },
    no: {
      signin: {
        button: 'Logg inn',
        message: 'Påfyll av Selfly-skap',
      },
      common: {
        signout: 'Logg ut',
        redirecting: 'Omdirigerer',
        start_read_qr: 'Start ved å lese enhetens QR-kode',
        no_permission_to_replenish_device:
          'Du har ikke nødvendige tillatelser for å fylle på skapet',
        please_wait_for_door_open: 'Vent til døren åpnes...',
        language: 'Velg språk',
        refill_app: 'Påfyllingsapp',
        plan_help_text:
          'Dette er målplanen som angir produktmengden som skal legges til eller fjernes fra skapet',
        no_plan: 'Det er ingen aktiv påfyllingsplan for dette skapet',
        yes: 'Ja',
        no: 'Nei',
        add: 'Legg til',
        remove: 'Fjern',
        refill: 'Påfyll',
        refillPlan: 'Påfyllplan',
        settings: 'Innstillinger',
        user: 'Bruker',
        products: 'Produkter',
        target: 'Mål',
        close: 'Lukk',
        refillNote: 'Påfyllingsnotat',
        planogramHelpText:
          'Planogramoppsett for plassering av produkter på skapets hyller under påfylling.',
        planogramMissing: 'Ingen planogram er definert.',
        planogramImageHelpText: 'Planogrambilde for påfyllingsplanen.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Advarsel: Påfyllingsplanen din er ennå ikke oppfylt, du kan sjekke fanen for påfyllingsplanen for å se de manglende elementene.',
        inventoryInfoSuccess:
          'Gratulerer, du har oppnådd påfyllingsplanen din!',
        inventory: 'Lager',
        screen: 'Skjerm',
        shelf: 'Hylle',
        slot: 'Plass',
        start_calibration: 'Start kalibrering',
        end_calibration: 'Avslutt kalibrering',
        unableToLoadPlanogram: 'Kan ikke laste planogram',
        selectSlot:
          'Trykk "Start" og velg en plass nedenfor for å begynne kalibreringen.',
        pressSlotToCalibrate:
          'Velg "Neste" hvis du er klar til å starte kalibreringen for den valgte plassen.',
        confirmSlotEmptied:
          'Sørg for at plassen er tom. Hvis det er produkter i plassen, fjern dem først. Klikk deretter på "Bekreft"-knappen for å bekrefte at plassen er tom.',
        back: 'Tilbake',
        next: 'Neste',
        confirm: 'Ja, bekreft',
        cancel: 'Avbryt',
        cancelCalibration:
          'Er du sikker på at du vil avbryte kalibreringen for denne plassen?',
        selectProduct: 'Velg et produkt',
        slotNotAssigned:
          'Et produkt er lagt til i planogrammet, men det er ennå ikke tildelt en spesifikk plass i skapet.',
        productMismatched:
          'Produktet som er tildelt den valgte plassen, er forskjellig fra produktet som er lagt til i planogrammet.',
        productMissing: 'Ingen produkt er tildelt plassen ennå.',
        searchProduct: 'søk produkt...',
        calibrationInProgress:
          'Velg en plass fra planogrammet nedenfor som du vil trene produktet for',
        placeProducts:
          'Plasser minst 3 og maksimalt 9 produkter i den valgte plassen.',
        productMissingInPlanogram:
          'Et produkt er tildelt den valgte plassen, men er ikke oppført i planogrammet.',
        confirmCalibrationProduct:
          'Er du sikker på at du har plassert {{count}} produkter i den valgte plassen?',
        updateSlotInventory: 'Oppdater sporinventar',
        updating: 'Oppdaterer...',
      },
      cabinet: {
        label_name: 'Skap',
        door_lock: 'Slutt',
        door_unlock: 'Start',
        applying_setting: 'Bruker innstillinger',
        filter_instruction:
          'Velg om du bare vil vise påfylte varer eller alle varene på skapets påfyllingsskjerm',
        all_items: 'Alle varer',
        refilled_items: 'Påfylte varer',
        refill_question:
          'Ønsker du å merke den aktive påfyllingsplanen for dette skapet som fullført?',
        refill_warning_question:
          'Din aktive påfyllingsplan for dette skapet er ennå ikke oppfylt. Vil du fortsatt markere det som fullført?',
      },
      error: {
        forbidden: 'Du har ikke tillatelse til å fylle på denne enheten',
        unknown: 'Noe gikk galt…',
        error: 'Feil',
        not_found_plan: 'Ingen påfyllingsplan ble funnet for dette apparatet',
        plan_status: 'Status for påfyllingsplanen kunne ikke oppdateres',
        cabinetState: 'Kunne ikke hente skapets status.',
      },
    },
    da: {
      signin: {
        button: 'Log ind',
        message: 'Selfly genopfyldning af skab',
      },
      common: {
        signout: 'Log ud',
        redirecting: 'Omdirigerer',
        start_read_qr: 'Start med at læse enhedens QR-kode',
        no_permission_to_replenish_device:
          'Du har ikke nødvendige tilladelser til at genopfylde dette skab',
        please_wait_for_door_open: 'Vent venligst indtil døren åbnes...',
        language: 'Vælg sprog',
        refill_app: 'Genopfyldningsapp',
        plan_help_text:
          'Dette er målplanen, som angiver det antal ​​produkter, der skal tilføjes eller fjernes fra skabet',
        no_plan: 'Der er ingen aktiv genopfyldningsplan for dette skab',
        yes: 'Ja',
        no: 'Nej',
        add: 'Tilføj',
        remove: 'Fjern',
        refill: 'Refill',
        refillPlan: 'Genopfyldningsplan',
        settings: 'Indstillinger',
        user: 'Bruger',
        products: 'Produkter',
        target: 'Mål',
        close: 'Luk',
        refillNote: 'Genopfyldningsnote',
        planogramHelpText:
          'Planogramlayout til placering af produkter på skabets hylder under påfyldning.',
        planogramMissing: 'Ingen planogram er defineret.',
        planogramImageHelpText: 'Planogrambillede til påfyldningsplanen.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Advarsel: Din påfyldningsplan er endnu ikke opfyldt, du kan tjekke fanen for påfyldningsplanen for at se de manglende varer.',
        inventoryInfoSuccess: 'Tillykke, du har opnået din påfyldningsplan!',
        inventory: 'Lager',
        screen: 'Skærm',
        shelf: 'Hylde',
        slot: 'Plads',
        start_calibration: 'Start kalibrering',
        end_calibration: 'Afslut kalibrering',
        unableToLoadPlanogram: 'Kan ikke indlæse planogram',
        selectSlot:
          'Tryk på "Start" og vælg en plads nedenfor for at begynde kalibreringen.',
        pressSlotToCalibrate:
          'Vælg "Næste", hvis du er klar til at starte kalibreringen for den valgte plads.',
        confirmSlotEmptied:
          'Sørg for, at pladsen er tom. Hvis der er produkter i pladsen, skal du fjerne dem først. Klik derefter på knappen "Bekræft" for at bekræfte, at pladsen er tom.',
        back: 'Tilbage',
        next: 'Næste',
        confirm: 'Ja, bekræft',
        cancel: 'Annuller',
        cancelCalibration:
          'Er du sikker på, at du vil annullere kalibreringen for denne plads?',
        selectProduct: 'Vælg et produkt',
        slotNotAssigned:
          'Et produkt er blevet tilføjet til planogrammet, men det er endnu ikke blevet tildelt en bestemt plads i skabet.',
        productMismatched:
          'Produktet, der er tildelt den valgte plads, adskiller sig fra det produkt, der er tilføjet til planogrammet.',
        productMissing: 'Der er endnu ikke tildelt et produkt til pladsen.',
        searchProduct: 'søg produkt...',
        calibrationInProgress:
          'Vælg en plads fra planogrammet nedenfor, som du vil træne produktet til',
        placeProducts:
          'Placer mindst 3 og højst 9 produkter i den valgte plads.',
        productMissingInPlanogram:
          'Et produkt er blevet tildelt den valgte plads, men er ikke angivet i planogrammet.',
        confirmCalibrationProduct:
          'Er du sikker på, at du har placeret {{count}} produkter i den valgte plads?',
        updateSlotInventory: 'Opdater pladsbeholdning',
        updating: 'Opdaterer...',
      },
      cabinet: {
        label_name: 'Skab',
        door_lock: 'Slut',
        door_unlock: 'Start',
        applying_setting: 'Anvender indstilling',
        filter_instruction:
          'Vælg, om der kun skal vises genopfyldte varer eller alle varer på skabets genopfyldningsskærm',
        all_items: 'Alle varer',
        refilled_items: 'Genopfyldte varer',
        refill_question:
          'Vil du markere den aktive genopfyldningsplan for dette skab som afsluttet?',
        refill_warning_question:
          'Din aktive påfyldningsplan for dette skab er endnu ikke opfyldt, vil du stadig markere det som fuldført?',
      },
      error: {
        forbidden: 'Du har ikke tilladelse til at genopfylde denne enhed',
        unknown: 'Der gik noget galt...',
        error: 'Fejl',
        not_found_plan:
          'Der blev ikke fundet nogen genopfyldningsplan for denne enhed',
        plan_status: 'Status for genopfyldningsplan kunne ikke opdateres',
        cabinetState: 'Kunne ikke hente skabets status.',
      },
    },
    cs: {
      signin: {
        button: 'Přihlášení',
        message: 'Doplnění kabinetu',
      },
      common: {
        signout: 'Odhlášení',
        redirecting: 'Přesměrování',
        start_read_qr: 'Začněte načtením QR kódu zařízení',
        no_permission_to_replenish_device:
          'Nemáte potřebné oprávnění k doplňování tohoto kabineu',
        please_wait_for_door_open:
          'Vyčkejte prosím, dokud se dveířka kabinetu neotevřou...',
        language: 'Vyberte jazyk',
        refill_app: 'Doplňovací aplikace',
        plan_help_text:
          'Cílový plán, který udává množství produktů, které mají být přidány/odebrány do/z kabinetu',
        no_plan:
          'Pro tento kabinet není vytvořen žádný aktivní plán doplňování',
        yes: 'Ano',
        no: 'Ne',
        add: 'Přidat',
        remove: 'Odstranit',
        refill: 'Doplnit',
        refillPlan: 'Doplňovací plán',
        settings: 'Nastavení',
        user: 'Uživatel',
        products: 'Produkty',
        target: 'Cíl',
        close: 'Zavřít',
        refillNote: 'Poznámka o doplnění',
        planogramHelpText:
          'Rozvržení planogramu pro umístění produktů na police skříně během doplňování.',
        planogramMissing: 'Není definován žádný planogram.',
        planogramImageHelpText: 'Obrázek planogramu pro plán doplňování.',
        planogram: 'Plánogram',
        inventoryInfoWarning:
          'Varování: Váš plán doplňování nebyl zatím splněn, můžete zkontrolovat záložku plánu doplňování a zjistit chybějící položky.',
        inventoryInfoSuccess:
          'Gratulujeme, dosáhli jste svého plánu doplňování!',
        inventory: 'Inventář',
        screen: 'Obrazovka',
        shelf: 'Police',
        slot: 'Slot',
        start_calibration: 'Spustit kalibraci',
        end_calibration: 'Ukončit kalibraci',
        unableToLoadPlanogram: 'Nelze načíst planogram',
        selectSlot:
          'Stiskněte "Spustit" a vyberte níže slot pro zahájení kalibrace.',
        pressSlotToCalibrate:
          'Vyberte "Další", pokud jste připraveni zahájit kalibraci pro vybraný slot.',
        confirmSlotEmptied:
          'Ujistěte se, že je slot prázdný. Pokud jsou ve slotu nějaké produkty, nejprve je odstraňte. Poté klikněte na tlačítko "Potvrdit" pro ověření, že je slot prázdný.',
        back: 'Zpět',
        next: 'Další',
        confirm: 'Ano, potvrdit',
        cancel: 'Zrušit',
        cancelCalibration:
          'Jste si jisti, že chcete zrušit kalibraci pro tento slot?',
        selectProduct: 'Vybrat produkt',
        slotNotAssigned:
          'Produkt byl přidán do planogramu, ale dosud nebyl přiřazen ke konkrétnímu slotu ve skříni.',
        productMismatched:
          'Produkt přiřazený k vybranému slotu se liší od produktu přidaného do planogramu.',
        productMissing: 'K slotu dosud nebyl přiřazen žádný produkt.',
        searchProduct: 'hledat produkt...',
        calibrationInProgress:
          'Vyberte slot z planogramu níže, pro který chcete produkt trénovat',
        placeProducts:
          'Umístěte do vybraného slotu minimálně 3 a maximálně 9 produktů.',
        productMissingInPlanogram:
          'K vybranému slotu byl přiřazen produkt, ale není uveden v planogramu.',
        confirmCalibrationProduct:
          'Jste si jisti, že jste do vybraného slotu umístili {{count}} produktů?',
        updateSlotInventory: 'Aktualizovat inventář slotů',
        updating: 'Aktualizuji...',
      },
      cabinet: {
        label_name: 'Kabinet',
        door_lock: 'Ukončit',
        door_unlock: 'Začít',
        applying_setting: 'Načítám nastavení',
        filter_instruction:
          'Zvolte, zda chcete na obrazovce kabinetu zobrazit jen doplněné produkty, nebo všechny produkty.',
        all_items: 'Všechny produkty',
        refilled_items: 'Doplněné produkty',
        refill_question:
          'Chcete označit aktivní plán doplňování pro tento kabinet jako dokončený?',
        refill_warning_question:
          'Váš aktivní plán doplňování pro tuto skříň zatím není splněn, přesto ho chcete označit jako dokončený?',
      },
      error: {
        forbidden: 'Nemáte potřebné oprávnění k doplňování tohoto zařízení',
        unknown: 'Něco se pokazilo...',
        error: 'Chyba',
        not_found_plan: 'Pro toto zařízení nebyl nalezen žádný plán doplňování',
        plan_status: 'Nepodařilo se aktualizovat plán doplňování',
        cabinetState: 'Nepodařilo se načíst stav skříně.',
      },
    },
    pt: {
      signin: {
        button: 'Entrar',
        message: 'Reabastecimento do Armário Selfly',
      },
      common: {
        signout: 'Sair',
        redirecting: 'Redirecionando',
        start_read_qr: 'Comece lendo o código QR do dispositivo',
        no_permission_to_replenish_device:
          'Você não tem permissões necessárias para reabastecer este armário',
        please_wait_for_door_open:
          'Por favor, aguarde até que a porta esteja aberta...',
        language: 'Selecione o idioma',
        refill_app: 'Aplicativo de Reabastecimento',
        plan_help_text:
          'Este é o plano alvo que indica a quantidade de produtos a serem adicionados ou removidos do armário',
        no_plan: 'Não há plano de reabastecimento ativo para este armário',
        yes: 'Sim',
        no: 'Não',
        add: 'Adicionar',
        remove: 'Remover',
        refill: 'Reabastecer',
        refillPlan: 'Plano de Reabastecimento',
        settings: 'Configurações',
        user: 'Usuário',
        products: 'Produtos',
        target: 'Alvo',
        close: 'Fechar',
        refillNote: 'Nota de reabastecimento',
        planogramHelpText:
          'Layout do planograma para a colocação de produtos nas prateleiras do armário durante o reabastecimento.',
        planogramMissing: 'Nenhum planograma foi definido.',
        planogramImageHelpText:
          'Imagem do planograma para o plano de reabastecimento.',
        planogram: 'Planograma',
        inventoryInfoWarning:
          'Aviso: O seu plano de reabastecimento ainda não foi cumprido, pode verificar o separador do plano de reabastecimento para ver os itens em falta.',
        inventoryInfoSuccess:
          'Parabéns, você atingiu seu plano de reabastecimento!',
        inventory: 'Inventário',
        screen: 'Ecrã',
        shelf: 'Prateleira',
        slot: 'Slot',
        start_calibration: 'Iniciar calibração',
        end_calibration: 'Finalizar calibração',
        unableToLoadPlanogram: 'Não é possível carregar o planograma',
        selectSlot:
          'Pressione "Iniciar" e escolha um slot abaixo para começar a calibração.',
        pressSlotToCalibrate:
          'Selecione "Próximo" se estiver pronto para iniciar a calibração para o slot escolhido.',
        confirmSlotEmptied:
          'Certifique-se de que o slot está vazio. Se houver produtos no slot, remova-os primeiro. Em seguida, clique no botão "Confirmar" para verificar se o slot está limpo.',
        back: 'Voltar',
        next: 'Próximo',
        confirm: 'Sim, confirmar',
        cancel: 'Cancelar',
        cancelCalibration:
          'Tem certeza de que deseja cancelar a calibração para este slot?',
        selectProduct: 'Selecionar um produto',
        slotNotAssigned:
          'Um produto foi adicionado ao planograma, mas ainda não foi atribuído a um slot específico no gabinete.',
        productMismatched:
          'O produto atribuído ao slot selecionado difere do produto adicionado ao planograma.',
        productMissing: 'Nenhum produto foi atribuído ao slot ainda.',
        searchProduct: 'pesquisar produto...',
        calibrationInProgress:
          'Selecione um slot no planograma abaixo para o qual deseja treinar o produto',
        placeProducts:
          'Coloque um mínimo de 3 e um máximo de 9 produtos no slot selecionado.',
        productMissingInPlanogram:
          'Um produto foi atribuído ao slot selecionado, mas não está listado no planograma.',
        confirmCalibrationProduct:
          'Tem certeza de que colocou {{count}} produtos no slot selecionado?',
        updateSlotInventory: 'Atualizar inventário de slot',
        updating: 'Atualizando...',
      },
      cabinet: {
        label_name: 'Armário',
        door_lock: 'Fechar',
        door_unlock: 'Abrir',
        applying_setting: 'Aplicando configuração',
        filter_instruction:
          'Selecione se deseja exibir apenas itens reabastecidos ou todos os itens na tela de reabastecimento do armário',
        all_items: 'Todos os itens',
        refilled_items: 'Itens reabastecidos',
        refill_question:
          'Você deseja marcar o plano de reabastecimento ativo para este armário como concluído?',
        refill_warning_question:
          'O seu plano de reabastecimento ativo para este armário ainda não foi cumprido. Ainda assim, deseja marcá-lo como concluído?',
      },
      error: {
        forbidden: 'Você não tem permissão para reabastecer este dispositivo',
        unknown: 'Algo deu errado...',
        error: 'Erro',
        not_found_plan:
          'Nenhum plano de reabastecimento foi encontrado para este dispositivo',
        plan_status:
          'O status do plano de reabastecimento não pôde ser atualizado',
        cabinetState: 'Não foi possível obter o estado do armário.',
      },
    },
    tr: {
      signin: {
        button: 'Giriş Yap',
        message: 'Selfly Refill',
      },
      common: {
        signout: 'Çıkış Yap',
        redirecting: 'Yönlendiriliyor',
        start_read_qr: 'Cihazın QR kodunu okuyarak başlayın',
        no_permission_to_replenish_device:
          'Bu dolabı doldurmak için gerekli yetkiye sahip değilsiniz',
        please_wait_for_door_open: 'Lütfen kapının açılmasını bekleyin...',
        language: 'Dil Seçin',
        refill_app: 'Dolum Uygulaması',
        plan_help_text:
          'Dolaba eklenmesi veya çıkarılması gereken ürün miktarını gösteren hedef planı',
        no_plan: 'Bu dolap için aktif bir dolum planı yok',
        yes: 'Evet',
        no: 'Hayır',
        add: 'Ekle',
        remove: 'Kaldır',
        refill: 'Dolum',
        refillPlan: 'Dolum Planı',
        settings: 'Ayarlar',
        user: 'Kullanıcı',
        products: 'Ürünler',
        target: 'Hedef',
        close: 'Kapat',
        refillNote: 'Dolum Notu',
        planogramHelpText:
          'Dolum sırasında ürünlerin dolap raflarına yerleştirilmesi için düzen görünümü.',
        planogramMissing: 'Dolum için bir planogram tanımlanmamış.',
        planogramImageHelpText: 'Dolum için planogram görseli.',
        planogram: 'Planogram',
        inventoryInfoWarning:
          'Uyarı: Dolum planınız henüz tamamlanmadı, eksik ürünleri görmek için dolum planı sekmesini kontrol edebilirsiniz.',
        inventoryInfoSuccess: 'Tebrikler, dolum planınızı tamamladınız!',
        inventory: 'Envanter',
        screen: 'Ekran',
        shelf: 'Raf',
        slot: 'Yuva',
        start_calibration: 'Kalibrasyonu başlat',
        end_calibration: 'Kalibrasyonu bitir',
        unableToLoadPlanogram: 'Planogram yüklenemiyor',
        selectSlot:
          'Kalibrasyonu başlatmak için "Başlat"a basın ve aşağıdan bir yuva seçin.',
        pressSlotToCalibrate:
          'Seçilen yuva için kalibrasyona başlamaya hazırsanız "İleri"yi seçin.',
        confirmSlotEmptied:
          'Lütfen yuvanın boş olduğundan emin olun. Yuvada herhangi bir ürün varsa, önce bunları çıkarın. Ardından, yuvanın boş olduğunu doğrulamak için "Onayla" düğmesine basın.',
        back: 'Geri',
        next: 'İleri',
        confirm: 'Evet, onayla',
        cancel: 'İptal',
        cancelCalibration:
          'Bu yuva için kalibrasyonu iptal etmek istediğinizden emin misiniz?',
        selectProduct: 'Bir ürün seçin',
        slotNotAssigned:
          'Planograma bir ürün eklendi, ancak dolaptaki yuvaya henüz atanmadı.',
        productMismatched:
          'Seçilen yuvaya atanan ürün, planograma eklenen üründen farklıdır.',
        productMissing: 'Yuvaya henüz bir ürün atanmadı.',
        searchProduct: 'ürün ara...',
        calibrationInProgress:
          'Ürünü tanıtmak istediğiniz aşağıdaki planogramdan bir yuva seçin',
        placeProducts:
          'Lütfen seçilen yuvaya minimum 3 ve maksimum 9 ürün yerleştirin.',
        productMissingInPlanogram:
          'Seçilen yuvaya bir ürün atandı, ancak planogramda listelenmiyor.',
        confirmCalibrationProduct:
          'Seçilen yuvaya {{count}} ürün yerleştirdiğinizden emin misiniz?',
        updateSlotInventory: 'Yuva envanterini güncelle',
        updating: 'Güncelleniyor...',
      },
      cabinet: {
        label_name: 'Dolap',
        door_lock: 'Bitir',
        door_unlock: 'Başlat',
        applying_setting: 'Ayar uygulanıyor',
        filter_instruction:
          'Dolabın ekranında yalnızca doldurulan ürünleri mi yoksa tüm ürünleri mi görmek istediğinizi seçin',
        all_items: 'Tüm ürünler',
        refilled_items: 'Doldurulan ürünler',
        refill_question:
          'Bu dolap için aktif dolum planını tamamlandı olarak işaretlemek istiyor musunuz?',
        refill_warning_question:
          'Bu dolap için aktif dolum planınız henüz tamamlanmadı, yine de tamamlandı olarak işaretlemek istiyor musunuz?',
      },
      error: {
        forbidden: 'Bu cihazı doldurma yetkiniz yok',
        unknown: 'Beklenmedik bir hata meydana geldi...',
        error: 'Hata',
        not_found_plan: 'Bu cihaz için bir dolum planı bulunamadı',
        plan_status: 'Dolum planı durumu güncellenemedi',
        cabinetState: 'Dolap durumu bilgisi alınamadı.',
      },
    },
  },
  fallbackLng: 'en',

  // have a common namespace used around the full app
  ns: ['common'],
  defaultNS: 'common',

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  react: {
    wait: true,
  },
});

export default i18n;
